// extracted by mini-css-extract-plugin
module.exports = {"link":"zEKf6","subMenuItem":"_2bUfv","title":"_3f_8g","description":"KTnxd"};